<template>
  <div>
    <label for="surveyDropdown">
      Survey <span v-if="required" class="required">*</span>
    </label>
    <multiselect
        id="surveyDropdown"
        v-model="survey"
        :options="surveys"
        label="text"
        track-by="id"
        :disabled="setDisable"
        style="margin: 0.6rem 0 0"
    />
  </div>
</template>

<script>
import SurveyService from "services/api/survey.service";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "SurveyDropdown",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    brandCode: { type: [String, Number], default: null },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      survey: this.value,
      surveys: [],
    };
  },
  watch: {
    value(newVal) {
      this.survey = newVal;
    },
    survey(newVal) {
      this.$emit("input", newVal);
      this.$emit("setSurvey", newVal);
    },
    brandCode(newBrand) {
      if (newBrand) {
        this.getSurveys(newBrand);
      } else {
        this.surveys = [];
        this.survey = null;
        this.$emit("input", null);
        this.$emit("setSurveys", []);
      }
    },
  },
  created() {
    if (this.brandCode) {
      this.getSurveys(this.brandCode);
    }
  },
  methods: {
    async getSurveys(brandCode) {
      try {
        emitLoadingStart(this);
        const res = await SurveyService.getListSurvey({ brandCode });

        const rows = res?.data?.data || [];
        this.surveys = rows
            .map(s => ({
              id: s.id,
              text: `${s.name} (id: ${s.id})`
            }))
            .sort((a, b) => a.text.localeCompare(b.text));

        this.$emit("setSurveys", this.surveys);


      } catch (error) {
        console.error("Error fetching surveys:", error);
        this.surveys = [];
        this.$emit("setSurveys", []);
      } finally {
        emitLoadingDone(this);
      }
    },
  },
};
</script>
